<template>
    <div class="card-selector" :class="{ 'card-selector--vertical': vertical }">
        <div
            v-for="option in options"
            :key="option.value"
            class="selector-card"
            :class="{
                'selector-card--selected': isSelected(option.value),
                'selector-card--with-icon': option.icon
            }"
            @click="selectOption(option.value)"
        >
            <div v-if="option.icon" class="card-icon">
                <v-icon size="32" :color="isSelected(option.value) ? 'primary' : '#666'">
                    {{ option.icon }}
                </v-icon>
            </div>
            <div class="card-content">
                <div class="card-label">{{ option.label }}</div>
                <div v-if="option.description" class="card-description">
                    {{ option.description }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CardSelector',

    props: {
        options: {
            type: Array,
            required: true
            // Each option: { value: string, label: string, icon?: string, description?: string }
        },
        value: {
            type: [String, Array],
            default: null
        },
        multiple: {
            type: Boolean,
            default: false
        },
        vertical: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        isSelected(optionValue) {
            if (this.multiple) {
                return Array.isArray(this.value) && this.value.includes(optionValue);
            }
            return this.value === optionValue;
        },

        selectOption(optionValue) {
            if (this.multiple) {
                const currentValue = Array.isArray(this.value) ? [...this.value] : [];
                const index = currentValue.indexOf(optionValue);

                if (index > -1) {
                    currentValue.splice(index, 1);
                } else {
                    currentValue.push(optionValue);
                }

                this.$emit('input', currentValue);
            } else {
                this.$emit('input', optionValue);
            }
        }
    }
};
</script>

<style scoped>
.card-selector {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
}

.card-selector--vertical {
    flex-direction: column;
}

.selector-card {
    flex: 1;
    min-width: 120px;
    padding: 20px;
    border: 2px solid #e0e0e0;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    background: white;
}

.card-selector--vertical .selector-card {
    flex-direction: row;
    text-align: left;
    align-items: center;
}

.selector-card:hover {
    border-color: #2D76E3;
    background: rgba(45, 118, 227, 0.02);
}

.selector-card--selected {
    border-color: #2D76E3;
    background: rgba(45, 118, 227, 0.08);
}

.card-icon {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: rgba(45, 118, 227, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
}

.card-selector--vertical .card-icon {
    margin-bottom: 0;
    margin-right: 16px;
    flex-shrink: 0;
}

.selector-card--selected .card-icon {
    background: rgba(45, 118, 227, 0.2);
}

.card-content {
    flex: 1;
}

.card-label {
    font-weight: 600;
    font-size: 16px;
    color: #333;
}

.card-description {
    font-size: 14px;
    color: #666;
    margin-top: 4px;
}

@media (max-width: 400px) {
    .card-selector:not(.card-selector--vertical) .selector-card {
        min-width: 100%;
    }
}
</style>
